import { BAN_REASON_LABEL, type BanInfo, penaltyLine } from './banReason.js';

/** 381 (#1271, design "Ban reason" 2): under a banned account's status, why, the penalty or note, who and when. */
export function BanReasonBox({ ban }: { ban: BanInfo }) {
  const label = BAN_REASON_LABEL[ban.reason] ?? ban.reason;
  const when = new Date(ban.at).toLocaleString('en-MY', {
    timeZone: 'Asia/Kuala_Lumpur',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
  return (
    <div
      data-testid="ban-reason"
      className="mt-2 rounded-md border-l-4 border-semantic-danger-text bg-semantic-danger-bg/40 px-3 py-2"
    >
      <span className="block font-medium text-ink">{label}</span>
      {ban.reason === 'unpaid_penalty' && ban.booking_ref && (
        <span className="block text-ink">{penaltyLine(ban)}</span>
      )}
      {ban.note && <span className="block text-steel">“{ban.note}”</span>}
      <span className="block text-xs text-steel">
        Banned{ban.by_name ? ` by ${ban.by_name}` : ''} · {when}
      </span>
    </div>
  );
}
